/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { PrimaryCarousel } from '@powdr/components';
import {
  CarouselControlPlacement,
  getIndicatorType,
  handleCustomIndicators,
  NavigationDirection,
} from '@powdr/constants';

import { SlideItem } from './components';
import { StyledSlider } from './styles';

export const Slider = ({
  className = '',
  isThumbnailsDisabled = false,
  numThumbnails = 3,
  allowFullscreen = false,
  isCenteredSlides = false,
  additionalControls = {},
  showControlArrows,
  showSlideTitles,
  slideIndicators,
  parentColorProfile,
  relationships,
}) => {
  const { slides } = relationships;
  const slidesAdjusted = (slides.length === 2) ? slides.concat(slides) : slides;
  const numThumbnailsControl = (numThumbnails) || 3;

  const SlideMap = () => useMemo(() => slidesAdjusted.filter((i) => !i?.isHideSlide).map((item) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SlideItem {...item} />
  )), []);

  return (
    <StyledSlider
      className={`${className} slider`}
      $colorProfile={parentColorProfile}
    >
      {(slides?.filter((i) => !i?.isHideSlide)?.length > 1)
        ? (
          <PrimaryCarousel
            colorProfile={parentColorProfile}
            isShowThumbnails={!isThumbnailsDisabled}
            isAutoRotate={false}
            allowFullscreen={allowFullscreen}
            isCenteredSlides={isCenteredSlides}
            controlSettings={{
              navigation: (showControlArrows) && {
                iconName: 'ui-arrow-circle-left',
                iconSize: 45,
                placement: CarouselControlPlacement.ON_SLIDE,
                classes: {
                  [NavigationDirection.PREVIOUS]: 'slider-control-previous',
                  [NavigationDirection.NEXT]: 'slider-control-next',
                },
              },
              pagination: (slideIndicators) ? {
                type: getIndicatorType(slideIndicators),
                placement: CarouselControlPlacement.ON_SLIDE,
                customBullets: handleCustomIndicators(slides, getIndicatorType(slideIndicators)),
              } : null,
              thumbnails: {
                slidesPerView: numThumbnailsControl,
                breakpoints: {
                  320: {
                    slidesPerView: Math.min(3, slides?.length),
                  },
                  960: {
                    slidesPerView: Math.min(numThumbnailsControl, slides?.length),
                  },
                },
              },
              slideTitles: showSlideTitles,
            }}
            {...additionalControls}
          >
            {SlideMap()}
          </PrimaryCarousel>
        ) : (
          SlideMap()
        )}
    </StyledSlider>
  );
};

Slider.propTypes = {
  className: PropTypes.string,
  isThumbnailsDisabled: PropTypes.bool,
  numThumbnails: PropTypes.number,
  relationships: PropTypes.shape().isRequired,
  allowFullscreen: PropTypes.bool,
  showControlArrows: PropTypes.bool,
  showSlideTitles: PropTypes.bool,
  slideIndicators: PropTypes.number,
  parentColorProfile: PropTypes.string.isRequired,
  additionalControls: PropTypes.shape({}),
  isCenteredSlides: PropTypes.bool,
};
